const KEY_PREFIX = 'kierrätyksensankarit'

export function setGameItem (gameId, key, value) {
  setItem(getGameKey(gameId, key), value)
}

export function getGameItem (gameId, key) {
  return getItem(getGameKey(gameId, key))
}

export function removeGameItem (gameId, key) {
  removeItem(getGameKey(gameId, key))
}

export function setItem (key, value) {
  if (!window.localStorage) return
  window.localStorage.setItem(getKey(key), value)
}

export function getItem (key) {
  if (!window.localStorage) return
  return window.localStorage.getItem(getKey(key))
}

export function removeItem (key) {
  if (!window.localStorage) return
  return window.localStorage.removeItem(getKey(key))
}

function getKey (key) {
  return `${KEY_PREFIX}_${key}`
}

function getGameKey (gameId, key) {
  return `${gameId}_${key}`
}

/**
 * Get items passing the given filter function, or all keys if no function is
 * given.
 */
export function getItems (filterFn = key => true) {
  return Object.fromEntries(
    Object.entries(window.localStorage)
      .filter(([key]) => key.indexOf(KEY_PREFIX) === 0)
      .filter(([key]) => filterFn(key)),
  )
}
